export default __webpack_public_path__ + "static/media/default.429435e9.png";